import { Controller } from "@hotwired/stimulus"

// Envoie un événement au pixel Meta depuis le JavaScript compilé :
//   <div data-controller="meta-event" data-meta-event-name-value="Lead"
//        data-meta-event-id-value="lead-42" hidden></div>
//
// ⛔ Pas de <script> écrit dans la page pour ça. Mesuré le 04/10/2026, en
// local et sur beb.tn : après un formulaire ou un clic pris en charge par
// Turbo, la politique de sécurité (CSP) bloque les scripts de la page, et le
// Lead du navigateur ne partait jamais. L'identifiant est celui de l'envoi
// serveur : Meta n'en compte qu'un.
export default class extends Controller {
  static values = { name: String, id: String }

  connect() {
    if (document.documentElement.hasAttribute("data-turbo-preview")) return
    if (typeof window.fbq !== "function" || !this.nameValue || !this.idValue) return
    if (this.dejaEnvoye()) return

    window.fbq("track", this.nameValue, {}, { eventID: this.idValue })
  }

  // Un retour arrière ou un rechargement ne renvoie pas l'événement.
  dejaEnvoye() {
    const cle = `meta-event:${this.nameValue}:${this.idValue}`
    try {
      if (window.sessionStorage.getItem(cle)) return true
      window.sessionStorage.setItem(cle, "1")
    } catch (_) {
      // Stockage indisponible : Meta dédoublonne de toute façon par identifiant.
    }
    return false
  }
}
